import React from "react"
import styled from "styled-components"

export const TriangleRightIcon = () => (<i className="rsk rsk-triangle-right" />)

export const DashIcon = () => (<i className="rsk rsk-dash" />)
export const ArrowIcon = () => (<i className="rsk rsk-arrow" />)

export const EyeIcon = () => (<i className="rsk rsk-eye" />)
export const EyeBlockedIcon = () => (<i className="rsk rsk-eye-blocked" />)

export const RadioCheckedIcon = () => (<i className="rsk rsk-radio-checked" />)
export const RadioUncheckedIcon = () => (<i className="rsk rsk-radio-unchecked" />)

export const CheckIcon = () => (<i className="fa fa-check" />)
export const CheckedIcon = () => (<i className="fa fa-check-square-o" />)
export const UncheckedIcon = () => (<i className="fa fa-square-o" />)

export const SpinnerIcon = () => (<i className="fa fa-spinner fa-pulse fa-3x fa-fw" />)

export const CloseIcon = () => (<i className="fa fa-close" />)
export const CrossIcon = () => (<i className="rsk rsk-cross" />)

export const ChevronRightIcon = () => (<i className="fa fa-chevron-right" />)
export const ChevronLeftIcon = () => (<i className="fa fa-chevron-left" />)
export const ChevronUpIcon = () => (<i className="fa fa-chevron-up" />)
export const ChevronDownIcon = () => (<i className="fa fa-chevron-down" />)

export const AngleRightIcon = () => (<i className="fa fa-angle-right" />)
export const AngleLeftIcon = () => (<i className="fa fa-angle-left" />)
export const AngleDownIcon = () => (<i className="fa fa-angle-down" />)

export const QuestionIcon = () => (<i className="fa fa-question-circle" />)
export const QuestionEmptyIcon = () => (<i className="fa fa-question-circle-o" />)
export const ExclamationIcon = () => (<i className="fa fa-exclamation-triangle" />)
export const NotificationIcon = () => (<i className="rsk rsk-notification" />)

export const PencilIcon = () => (<i className="fa fa-pencil" />)
export const ClockIcon = () => (<i className="rsk rsk-clock" />)
export const ClockThinIcon = () => (<i className="rsk rsk-clock-thin" />)
export const BookIcon = () => (<i className="rsk rsk-book" />)

export const FileIcon = () => (<i className="fa fa-file-text-o" />)
export const DownloadIcon = () => (<i className="fa fa-download" />)

export const Bars = () => (<i className="fa fa-bars" />)
export const EllipsisIcon = () => (<i className="fa fa-ellipsis-v" />)
export const Blocks = () => (<i className="rsk rsk-blocks" />)

export const CogIcon = () => (<i className="fa fa-cog" />)
export const MinusIcon = () => (<i className="fa fa-minus" />)
export const PlusIcon = () => (<i className="fa fa-plus" />)
export const PauseIcon = () => (<i className="rsk rsk-pause" />)
export const ResumeIcon = () => (<i className="rsk rsk-resume" />)

export const PaperclipIcon = () => (<i className="fa fa-paperclip" />)
export const AddToTextIcon = () => (<i className="rsk rsk-addToText" />)
export const AddedToTextIcon = () => (<i className="rsk rsk-addedToText" />)

export const DelegateIcon = () => (<i className="rsk rsk-delegate" />)

export const OpenIcon = () => (<i className="rsk rsk-open" />)
export const RenameIcon = () => (<i className="rsk rsk-rename" />)
export const MoveIcon = () => (<i className="rsk rsk-move" />)
export const RemoveIcon = () => (<i className="rsk rsk-remove" />)

export const NewFileIcon = () => (<i className="rsk rsk-new-file" />)
export const NewFolderIcon = () => (<i className="rsk rsk-new-folder" />)
export const NoDataIcon = () => (<i className="rsk rsk-no-data" />)

export const CloudIcon = () => (<i className="fa fa-cloud" />)
export const UpdateIcon = () => (<i className="fa fa-refresh" />)
export const UndoIcon = () => (<i className="fa fa-undo" />)

export const CartIcon = () => (<i className="rsk rsk-cart" />)

export const IncreaseToIcon = () => (<i className="rsk rsk-increase-to" />)
export const DecreaseToIcon = () => (<i className="rsk rsk-decrease-to" />)

export const CopyEmptyIcon = () => (<i className="rsk rsk-copy-empty" />)
export const CopyFullIcon = () => (<i className="rsk rsk-copy-full" />)

const AmazonIconWrapper = styled.span`
    margin: 0 5px;
    color: ${(props) => props.theme.driveAmazonIconColor};
`
export const AmazonIcon = () => (
    <AmazonIconWrapper>
        <i className="fa fa-amazon" />
    </AmazonIconWrapper>
)


const GoogleIconWrapper = styled.span`
    margin: 0 5px;
    color: ${(props) => props.theme.driveGoogleIconColor};
`
export const GoogleIcon = () => (
    <GoogleIconWrapper>
        <i className="fa fa-google" />
    </GoogleIconWrapper>
)


const OneDriveIconWrapper = styled.span`
    height: 22px;
    line-height: 20px;
    margin: 0 5px;
    font-size: 20px;
    color: ${(props) => props.theme.driveMicrosoftIconColor};
`
export const OneDriveIcon = () => (
    <OneDriveIconWrapper>
        <i className="rsk rsk-microsoft-onedrive" />
    </OneDriveIconWrapper>
)


export interface FireIconProps {
    active: boolean
}
const FireIconWrapper = styled.div<FireIconProps>`
    font-size: 16px;
    color: ${(props) => (props.active ? props.theme.fireIconActiveColor : props.theme.fireIconInactiveColor)};
`
export const FireIcon = ({
    active,
}: FireIconProps) => (
    <FireIconWrapper active={active}>
        <i className="rsk rsk-fire" />
    </FireIconWrapper>
)
